import { MergeTag, MergeTagType } from '../types';

export const dedupeMergeTags = (mergeTags: MergeTag[]) => {
  const usedFieldNames: Record<MergeTagType, Record<string, true>> = {
    [MergeTagType.User]: {},
    [MergeTagType.Event]: {},
  };
  return mergeTags.filter(({ fieldName, type }) => {
    if (!usedFieldNames[type][fieldName]) {
      usedFieldNames[type][fieldName] = true;
      return true;
    }
    return false;
  });
};
